export enum ActionType {
    continue = 'continue',
    redirect = 'redirect',
    stopNavigation = 'stop-navigation',
}
